import React from 'react';

import { defaultTo, prop } from 'ramda';

import campaign from '../../../images/campaigns.svg';

import { FOHImage } from '../../ingredients';

export const FOHCampaignIcon = (props: any) => (
  <FOHImage
    source={{ uri: campaign }}
    style={{ width: 24, height: 24, ...defaultTo({}, prop('style', props)) }}
  />
);
